'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useEffect, useState } from 'react';
import { CartCount } from '@/components/molecule/CartCount';
import { OptionPriceSummary } from '../../_components/OptionPriceSummary';
import { OptionSelectBox } from '../../_components/OptionSelectBox';
import { optionKey } from '../_utils/cartCalculations';
import type { CartOption, CartProduct } from './CartShopGroup';
interface CartOptionChangeModalProps {
  opened: boolean;
  onClose: () => void;
  product: CartProduct;
  allOptions: CartOption[];
  onConfirm: (updatedOptions: CartOption[]) => void;
}
interface LocalOption extends CartOption {
  isSelected: boolean;
}
export const CartOptionChangeModal = t0 => {
  const $ = _c(67);
  const {
    opened,
    onClose,
    product,
    allOptions,
    onConfirm
  } = t0;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  let t1;
  if ($[0] !== product.options) {
    t1 = () => product.options.filter(_temp).map(_temp2);
    $[0] = product.options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [localOptions, setLocalOptions] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== opened || $[3] !== product.options) {
    t2 = () => {
      if (opened) {
        setLocalOptions(product.options.filter(_temp3).map(_temp4));
        setIsDropdownOpen(false);
      }
    };
    t3 = [opened, product.options];
    $[2] = opened;
    $[3] = product.options;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let T0;
  let T1;
  let availableOptions;
  let handleQuantityChange;
  let handleRemoveOption;
  let handleSelectOption;
  let t10;
  let t11;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let totalAmount;
  if ($[6] !== allOptions || $[7] !== localOptions || $[8] !== onClose || $[9] !== onConfirm || $[10] !== opened) {
    availableOptions = allOptions.filter(_temp5);
    let t12;
    if ($[26] !== localOptions) {
      t12 = localOptions.reduce(_temp6, 0);
      $[26] = localOptions;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    totalAmount = t12;
    if ($[28] !== localOptions) {
      handleSelectOption = option => {
        const key = optionKey(option);
        const existing = localOptions.find(lo => optionKey(lo) === key);
        if (existing) {
          handleQuantityChange(optionKey(existing), existing.quantity + 1);
        } else {
          setLocalOptions(prev => [...prev, {
            ...option,
            quantity: 1,
            isSelected: true
          }]);
        }
        setIsDropdownOpen(false);
      };
      handleQuantityChange = (key_0, quantity) => {
        setLocalOptions(prev_0 => prev_0.map(opt_5 => optionKey(opt_5) === key_0 ? {
          ...opt_5,
          quantity
        } : opt_5));
      };
      $[28] = localOptions;
      $[29] = handleQuantityChange;
      $[30] = handleSelectOption;
    } else {
      handleQuantityChange = $[29];
      handleSelectOption = $[30];
    }
    let t13;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = key_1 => {
        setLocalOptions(prev_1 => prev_1.filter(opt_6 => optionKey(opt_6) !== key_1));
      };
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    handleRemoveOption = t13;
    T1 = Modal;
    t6 = opened;
    t7 = onClose;
    t8 = "\uC635\uC158 \uBCC0\uACBD";
    t9 = true;
    t10 = "max-h-[90%] min-w-[26rem]";
    if ($[32] !== localOptions || $[33] !== onClose || $[34] !== onConfirm) {
      t11 = <Button className="w-full !rounded-none bg-O-400 font-700 hover:bg-O-300" onClick={() => {
        onConfirm(localOptions);
        onClose();
      }}>옵션 변경</Button>;
      $[32] = localOptions;
      $[33] = onClose;
      $[34] = onConfirm;
      $[35] = t11;
    } else {
      t11 = $[35];
    }
    t5 = "mt-24 flex flex-col gap-16";
    T0 = OptionSelectBox;
    t4 = availableOptions.map(_temp7);
    $[6] = allOptions;
    $[7] = localOptions;
    $[8] = onClose;
    $[9] = onConfirm;
    $[10] = opened;
    $[11] = T0;
    $[12] = T1;
    $[13] = availableOptions;
    $[14] = handleQuantityChange;
    $[15] = handleRemoveOption;
    $[16] = handleSelectOption;
    $[17] = t10;
    $[18] = t11;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = totalAmount;
  } else {
    T0 = $[11];
    T1 = $[12];
    availableOptions = $[13];
    handleQuantityChange = $[14];
    handleRemoveOption = $[15];
    handleSelectOption = $[16];
    t10 = $[17];
    t11 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
    totalAmount = $[25];
  }
  let t12;
  if ($[36] !== isDropdownOpen) {
    t12 = () => setIsDropdownOpen(!isDropdownOpen);
    $[36] = isDropdownOpen;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== availableOptions || $[39] !== handleSelectOption) {
    t13 = opt_8 => {
      const original = availableOptions.find(o => optionKey(o) === opt_8.id);
      if (original) {
        handleSelectOption(original);
      }
    };
    $[38] = availableOptions;
    $[39] = handleSelectOption;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== T0 || $[42] !== isDropdownOpen || $[43] !== t12 || $[44] !== t13 || $[45] !== t4) {
    t14 = <T0 options={t4} isOpen={isDropdownOpen} onToggle={t12} onSelectOption={t13} />;
    $[41] = T0;
    $[42] = isDropdownOpen;
    $[43] = t12;
    $[44] = t13;
    $[45] = t4;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== handleQuantityChange || $[48] !== handleRemoveOption || $[49] !== localOptions) {
    t15 = localOptions.length > 0 && <div className="flex flex-col gap-8">{localOptions.map((option_0, index) => {
        const key_2 = optionKey(option_0);
        return <div key={key_2} className="flex flex-col gap-8 bg-Gray-50 p-12"><p className="text-left font-400 text-Gray-600 typo-body4 mobile-tablet:typo-caption1">{String(index + 1).padStart(2, "0")}. {option_0.optionName}{option_0.extraPrice > 0 && ` (+${option_0.extraPrice.toLocaleString()}원)`}</p><div className="flex items-center justify-between"><CartCount className="rounded-none" count={option_0.quantity} onCountChange={count => handleQuantityChange(key_2, count)} onDelete={() => handleRemoveOption(key_2)} /><span className="font-600 text-Gray-900 typo-body3">{(option_0.price * option_0.quantity).toLocaleString()}원</span></div></div>;
      })}</div>;
    $[47] = handleQuantityChange;
    $[48] = handleRemoveOption;
    $[49] = localOptions;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== totalAmount) {
    t16 = <OptionPriceSummary totalAmount={totalAmount} className="mt-8 border-t border-Gray-200 py-0 pt-16" priceClassName="text-Gray-900 typo-h5" />;
    $[51] = totalAmount;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] !== t14 || $[54] !== t15 || $[55] !== t16 || $[56] !== t5) {
    t17 = <div className={t5}>{t14}{t15}{t16}</div>;
    $[53] = t14;
    $[54] = t15;
    $[55] = t16;
    $[56] = t5;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  let t18;
  if ($[58] !== T1 || $[59] !== t10 || $[60] !== t11 || $[61] !== t17 || $[62] !== t6 || $[63] !== t7 || $[64] !== t8 || $[65] !== t9) {
    t18 = <T1 opened={t6} onClose={t7} header={t8} closeButton={t9} className={t10} buttonFooter={t11}>{t17}</T1>;
    $[58] = T1;
    $[59] = t10;
    $[60] = t11;
    $[61] = t17;
    $[62] = t6;
    $[63] = t7;
    $[64] = t8;
    $[65] = t9;
    $[66] = t18;
  } else {
    t18 = $[66];
  }
  return t18;
};
function _temp(opt) {
  return !opt.soldOutYN;
}
function _temp2(opt_0) {
  return {
    ...opt_0,
    isSelected: true
  };
}
function _temp3(opt_1) {
  return !opt_1.soldOutYN;
}
function _temp4(opt_2) {
  return {
    ...opt_2,
    isSelected: true
  };
}
function _temp5(opt_3) {
  return !opt_3.soldOutYN;
}
function _temp6(sum, opt_4) {
  return sum + opt_4.price * opt_4.quantity;
}
function _temp7(opt_7) {
  return {
    ...opt_7,
    id: optionKey(opt_7),
    name: opt_7.optionName
  };
}